import {Tableau} from './Tableau';
import {createDefaultContent} from './utils';
export * from './constants';

export default Tableau;

export {
  createDefaultContent as createTableauContent,
}
